import moment from "moment";

angular
    .module("Finance")
    .controller("invoiceBrowseController", [
        "$scope", "$sessionStorage", "$http", "$activity", "$notification", "$state", "$fileService", "$oidc",
        function ($scope, $sessionStorage, $http, $activity, $notification, $state, $fileService, oidc) {
            // Storage
            $scope.$storage = $sessionStorage.$default({
                invoiceBrowse: {
                    invoiceNo: null,
                    dateFrom: moment()
                        .add(-1, "weeks")
                        .toDate(),
                    dateTo: moment().toDate(),
                    domain: null,
                    orderName: "CreateDate",
                    orderDesc: true
                }
            });

            if (!angular.isUndefinedNullOrEmpty($state.params.invoiceNo)) {
                $scope.$storage.invoiceBrowse.invoiceNo = $state.params.invoiceNo;
            }

            // Retailer
            $scope.$watch("$storage.retailer", function (newValue, oldValue) {
                if (newValue.Id !== oldValue.Id) {
                    $scope.refresh();
                }
            });

            // Date pickers
            $scope.fromOpen = function ($event) {
                $event.preventDefault();
                $event.stopPropagation();

                $scope.fromOpened = true;
            };

            $scope.toOpen = function ($event) {
                $event.preventDefault();
                $event.stopPropagation();

                $scope.toOpened = true;
            };

            // Browse
            $scope.sorting = function (orderName) {
                if ($scope.$storage.invoiceBrowse.orderName === orderName) {
                    $scope.$storage.invoiceBrowse.orderDesc = !$scope.$storage.invoiceBrowse
                        .orderDesc;
                } else {
                    $scope.$storage.invoiceBrowse.orderName = orderName;
                    $scope.$storage.invoiceBrowse.orderDesc = false;
                }
            };

            $scope.sortingClass = function (orderName) {
                if ($scope.$storage.invoiceBrowse.orderName === orderName) {
                    if ($scope.$storage.invoiceBrowse.orderDesc) {
                        return "fa fa-caret-down";
                    } else {
                        return "fa fa-caret-up";
                    }
                } else {
                    return "";
                }
            };

            $scope.loadDomains = function () {
                $activity.start();
                return $http
                    .get("/api/domain", {
                        headers: {
                            Authorization: oidc.current.token_type + " " + oidc.current.access_token
                        }
                    })
                    .then(
                        function (response) {
                            $scope.domains = response.data;
                            if ($scope.$storage.invoiceBrowse.domain === null) {
                                $scope.$storage.invoiceBrowse.domain = $scope.domains[0];
                            }
                        },
                        function (response) {
                            $notification.addError(response.statusText);
                        }
                    )
                    .then(function () {
                        $activity.finish();
                    });
            };

            $scope.refresh = function () {
                if (
                    angular.isUndefinedNullOrEmpty($scope.$storage.invoiceBrowse.invoiceNo)
                ) {
                    $scope.search();
                } else {
                    $scope.searchByInvoiceNo();
                }
            };

            $scope.search = function () {
                $activity.start();
                $http
                    .get("/api/invoice/browse/", {
                        params: {
                            retailerId: $scope.$storage.retailer.Id,
                            dateFrom: $scope.$storage.invoiceBrowse.dateFrom,
                            dateTo: $scope.$storage.invoiceBrowse.dateTo,
                            domainId: $scope.$storage.invoiceBrowse.domain.Id
                        },
                        headers: {
                            Authorization: oidc.current.token_type + " " + oidc.current.access_token
                        }
                    })
                    .then(
                        function (response) {
                            $scope.list = response.data;
                        },
                        function (response) {
                            $notification.addError(response.statusText);
                        }
                    )
                    .then(function () {
                        $activity.finish();
                    });
            };

            $scope.searchByInvoiceNo = function () {
                if (
                    !angular.isUndefinedNullOrEmpty($scope.$storage.invoiceBrowse.invoiceNo)
                ) {
                    $activity.start();
                    $http
                        .get("/api/invoice/invoiceNo/", {
                            params: {
                                retailerId: $scope.$storage.retailer.Id,
                                invoiceNo: $scope.$storage.invoiceBrowse.invoiceNo
                            },
                            headers: {
                                Authorization: oidc.current.token_type + " " + oidc.current.access_token
                            }
                        })
                        .then(
                            function (response) {
                                $scope.list = response.data;
                            },
                            function (response) {
                                $notification.addError(response.statusText);
                            }
                        )
                        .then(function () {
                            $activity.finish();
                        });
                } else {
                    $scope.search();
                }
            };

            // Generate excel
            $scope.generateExcel = function () {
                var invoiceIds = [];
                if (!angular.isUndefinedOrNull($scope.list)) {
                    for (var i = 0; i < $scope.list.length; i++) {
                        invoiceIds.push($scope.list[i].Id);
                    }
                }

                if (invoiceIds.length > 0) {
                    $activity.start();
                    $http
                        .get("/api/invoice/generate/", {
                            params: {
                                retailerId: $scope.$storage.retailer.Id,
                                invoiceIds: invoiceIds
                            },
                            headers: {
                                Authorization: oidc.current.token_type + " " + oidc.current.access_token
                            }
                        })
                        .then(
                            function (response) {
                                $fileService.downloadFile(response.data);
                            },
                            function (response) {
                                $notification.addError(response.statusText);
                            }
                        )
                        .then(function () {
                            $activity.finish();
                        });
                }
            };

            $scope.downloadInvoice = function (invoiceId) {
                $activity.start();
                $http
                    .get("/api/invoice/" + invoiceId + "/retailer/" + $scope.$storage.retailer.Id + "/download", {
                        headers: {
                            Authorization: oidc.current.token_type + " " + oidc.current.access_token
                        },
                        responseType: 'arraybuffer',
                    })
                    .then(
                        function (response) {
                            $fileService.saveResponseToFile(response);
                        },
                        function (response) {
                            $notification.addError(response.statusText);
                        }
                    )
                    .then(function () {
                        $activity.finish();
                    });
            }

            // Processed
            $scope.setProcessed = function (invoice) {
                $activity.start();
                $http
                    .put(
                        "/api/invoice/" + invoice.Id + "/processed",
                        {},
                        {
                            params: {
                                retailerId: $scope.$storage.retailer.Id,
                                value: invoice.IsProcessed
                            },
                            headers: {
                                Authorization: oidc.current.token_type + " " + oidc.current.access_token
                            }
                        }
                    )
                    .then(
                        function (response) { },
                        function (response) {
                            $notification.addError(response.statusText);
                        }
                    )
                    .then(function () {
                        $activity.finish();
                    });
            };

            // On Load
            $scope.loadDomains().then(function () {
                $scope.refresh();
            });
        }
    ]);